<template>
  <v-container class="no-padding" style="background: #EEE;">

    <div class="absolute bold center"
      style="right: 12rem; top: 8rem; font-size: 80px; color: #34D0B4;"
    >
      Em Manutenção
      <div class="bold black-text mt-4 absolute"
        style="font-size: 20px;"
      >
        Perdoe o transtorno, estamos atualizando a Trinity para melhorar a sua experiência. <br />
        O sistema retornará automaticamente assim que a atualização estiver concluída. <br />
        Por favor, aguarde.
      </div>
    </div>

    <div class="absolute"
      style="bottom: 0; left: 2rem;"
    >
      <Trini500Icon />
    </div>
  </v-container>
</template>

<script>
import Trini500Icon from '@/components/icons/Trini500Icon.vue';

// Página de manutenção
export default {
  name: 'ManutencaoView',
  components: { Trini500Icon },
  methods: {},
};
</script>

<style>
</style>
